import { FC } from 'react'
import { TBlogPostResult } from 'common/cms-types'
import Link from 'next/link'
import { linkResolver } from '../../linkResolver'
import PrismicImage from 'components/PrismicImage'

type BlogPostResultType = {
  post: TBlogPostResult
  size: 'sm' | 'md' | 'lg'
}

const BlogPostResult: FC<BlogPostResultType> = ({ post, size = 'sm' }) => {
  const { data } = post

  return (
    <Link className='a-unstyled' href={linkResolver(post as any)}>
      <div
        className={`cursor-pointer blog-results__item blog-results__item--${size}`}
      >
        {(size === 'md' || size === 'sm') && (
          <>
            <div
              className={`blog-results__img-container blog-results__img-container--${size}`}
            >
              <PrismicImage image={data.main_image} />
            </div>
            {size === 'md' && (
              <div className={'px-6 pt-6 pb-8'}>
                <h4 className={'text-semibold'}>{data.title}</h4>
                <p className={'text-small-m text-muted mb-0'}>
                  {data.modified_date}
                </p>
              </div>
            )}
            {size === 'sm' && (
              <div className={'px-4 pt-4 pb-6'}>
                <p className={'text-large text-semibold'}>{data.title}</p>
                <p className={'text-small-m text-muted mb-0'}>
                  {data.modified_date}
                </p>
              </div>
            )}
          </>
        )}
        {size === 'lg' && (
          <div className={'d-flex h-100'}>
            <div className={'ps-0 h-100 pe-4 w-75'}>
              <img
                className='w-100 object-fit-cover'
                src={data.main_image.url}
              />
            </div>
            <div className={'flex-fill w-50 ps-4 pe-8 py-8'}>
              <h4 className={'text-semibold'}>{data.title}</h4>
              <p className={'text-small-m text-muted mb-2'}>
                {data.modified_date}
              </p>
              <p className={'text-medium text-medium--lt2 mb-0'}>
                {data.body_excerpt}
              </p>
            </div>
          </div>
        )}
      </div>
    </Link>
  )
}

export default BlogPostResult
